





































































































































































import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Types
import {
  IConditionProductsProviderData,
  IConditionProductsProviderMethods
} from "@/models/providers/affiliateTierConditions";
import { IProduct } from "@/models/products";

@Component({
  components: {
    "empty-image": () =>
      import("@/components/base/ImageGallery/emptyPreviewImage.vue")
  }
})
export default class ConditionProductsTable extends Vue {
  // Inject

  @Inject({ from: "conditionProductsProviderData" })
  public readonly $conditionProductsProviderData!: () => IConditionProductsProviderData;

  public get conditionProducts() {
    return this.$conditionProductsProviderData();
  }

  @Inject({ from: "conditionProductsProviderMethods" })
  public readonly $conditionProductsProviderMethods!: IConditionProductsProviderMethods;

  public get conditionProductsMethods() {
    return this.$conditionProductsProviderMethods;
  }

  // Props

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public preSelectedProducts: IProduct["id"][] = [];
  public allSelectedProducts = false;

  // Methods

  public preSelect(productId) {
    if (this.preSelectedProducts.includes(productId)) {
      this.preSelectedProducts = this.$_.filter(
        this.preSelectedProducts,
        preSelectedProductId => preSelectedProductId !== productId
      );
    } else {
      this.preSelectedProducts.push(productId);
    }
  }

  public selectAllProducts(value) {
    if (!value) {
      this.preSelectedProducts = [];
      return;
    }

    this.preSelectedProducts = this.$_.map(
      this.conditionProducts.table.data,
      tableProduct => tableProduct.id
    );
  }

  public get selectedProductIds() {
    return this.$_.map(this.conditionProducts.table.data, "id");
  }

  @Watch("preSelectedProducts")
  public onPreSelectedProductsChange() {
    this.$set(
      this,
      "allSelectedProducts",
      this.preSelectedProducts.length > 0 &&
        this.preSelectedProducts.length ===
          this.conditionProducts.table.data.length
    );
  }

  @Watch("selectedProductIds")
  public onSelectedProductIdsChange() {
    this.preSelectedProducts = [];
    this.allSelectedProducts = false;
  }
}
